import { formatAmount, formatMoney, formatRate } from '@sebastian/shared';

export { formatAmount, formatMoney, formatRate };

/** 19:32 — the only clock format the floor ever needs. */
export function formatClock(iso: string | Date | null | undefined): string {
  if (!iso) return '--:--';
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  return date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
}

export function formatDate(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  return date.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  return `${formatDate(iso)} · ${formatClock(iso)}`;
}

/** Elapsed minutes since `iso`, as a whole number. */
export function minutesSince(iso: string | Date, now: number = Date.now()): number {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  return Math.max(0, Math.floor((now - date.getTime()) / 60_000));
}

/** "08 min" / "1h 12m" — a waiting time the kitchen can read across the pass. */
export function formatWaiting(iso: string | Date, now: number = Date.now()): string {
  const minutes = minutesSince(iso, now);
  if (minutes < 60) return `${String(minutes).padStart(2, '0')} min`;
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, '0')}m`;
}

export function pluralise(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function titleCase(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
